import { Component, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { Dictionary } from '@ngrx/entity';
import { JoiEvent, Ranking } from 'globals/store/events.data';
import { Wrapper } from 'src/app/components/wrapper.component';
import { RankingDialogData, RankSelectDialogComponent } from '../../modules/sponsors/rank-select.dialog.component';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { CoreEntityType } from 'globals/store/share.data';
import { titleCase } from '../../helpers/helpers';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';
import { IdsToItemsPipe } from 'src/app/services/pipes/sortByIds.pipe';
import { DialogPositionNumbers } from 'globals/store/dialog.selector.data';

@Component({
    selector: 'type-select-dropdown',
    template: `
<div class="label" *ngIf="!hideLabel">{{ label }}</div>
<div #typesRef class="types" *ngIf="ids | idsToItems:types as ts">
  <div *ngIf="!!entityType" (click)="selectTypes($event)">  
    {{  ( types[selectedId]?.name || noneSelectedText ) }}
  </div>
  <icon class="caret" [icon]="'expand18'" (click)="selectTypes($event)"></icon>
</div>
`,
    styles: [`
  :host { display: flex; cursor: pointer; align-items: center; }
  .types { display: flex;  padding: 0 3px 0 8px; align-items: center; border-radius: 6px; border: 1px solid #ddd; }
  .label { margin-right: 5px; }
`],
    standalone: true,
    imports: [IconComponent, CommonModule, IdsToItemsPipe]
})
export class EntityTypeDropdownComponent extends Wrapper<EntityTypeDropdownComponent> {
  @Input() entityType: CoreEntityType = null
  @Input() types: Dictionary<Ranking> = {}
  @Input() ids: string[] = []
  @Input() selectedId: string = null
  @Input() label = 'Visible to:'
  @Input() hideLabel = false
  @Input() noneSelectedText = 'All types'
  @Output() selectIds: EventEmitter<string[]> = new EventEmitter()
  @Output() selectId: EventEmitter<string> = new EventEmitter()
  @ViewChild('typesRef') typesRef: ElementRef<HTMLDivElement>
  maxTypesHeight = 400
  event: JoiEvent

  async selectTypes(ev: Event) {
    ev.stopPropagation()
    const rect = this.typesRef.nativeElement.getBoundingClientRect()
    window['rect'] = rect
    let position: DialogPositionNumbers
    if (window.innerHeight <= rect.bottom + this.maxTypesHeight) {
      position = { bottom:  window.innerHeight - rect.top + 3, left: rect.right - 300 }
    } else {
      position = { top: rect.bottom - 10, left: rect.right - 300  }
    }
    
    const data: RankingDialogData = {
      position,
      ranks: Object.values(this.types),
      selectedIds: null,
      selectedRankId: this.selectedId,
      type: `${titleCase(this.entityType)} Type`,
    }

    console.log({ data, position, this: this })

    const oldLevelsSerialized = JSON.stringify(data.ranks)
    await openDialogGetResult(this.dialog, RankSelectDialogComponent, { width: '300px', disableClose: false, data, backdropClass: 'clear' }) // mutates data in place
    const { selectedIds, ranks } = data
    console.log({ selectedIds, ranks })
  
    if (JSON.stringify(ranks) !== oldLevelsSerialized) {
      switch (this.entityType) {
        // case 'attendee':
        //   await this.attendeeService.updateTypes(ranks)
        //   break
        // case 'performer':
        //   await this.performerService.updateTypes(ranks)
        //   break
        // case 'sponsor':
        //   await this.sponsorService.updateSponsorTypes(ranks)
        //   break
        // case 'resource':
        //   await this.resourceService.updateTypes(ranks)
        //   break
        // case 'exhibitor':
        //   await this.exhibitorService.updateTypes(ranks)
        //   break
        default:
          console.log(`No update logic for update ${this.entityType} types`)
          break       
      }
    }

    this.selectId.emit(data.selectedRankId)
    return
  }

}